package io.horion.cv.components.cards

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.TextDescriptionFormStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px


@Composable
fun <T> GenericFormCardNew (
    item: T,
    isEditing: Boolean,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    onComplete: () -> Unit,
    getSummary: (T) -> SummaryData?,
    getDefaultText: () -> String,
    formContent: @Composable (T, () -> Unit, () -> Unit) -> Unit,
    isMobile: Boolean = false,
    isTablet: Boolean = false,
) {
    Column(
        modifier = TextDescriptionFormStyle.toModifier()
            .fillMaxWidth()
            .borderRadius(12.px)
            .border(1.px, LineStyle.Solid, Colors.Placeholder)
            .padding(if (isMobile) 15.px else 30.px)

    ) {
        if (isEditing) {
            formContent( item, onDelete, onComplete )
        } else {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(if (isMobile) 12.px else 20.px),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                val summary = getSummary(item)

                if (summary != null) {
                    Column(
                        verticalArrangement = Arrangement.spacedBy(10.px),
                    ) {
                        SpanText(
                            text = summary.title,
                            modifier = Modifier
                                .fontSize(if (isMobile) 14.px else 18.px)
                                .fontWeight(FontWeight.Bold)
                                .color(Colors.Black)
                                .fontFamily(INTER)
                        )
                        SpanText(
                            text = summary.subtitle,
                            modifier = Modifier
                                .fontSize(if (isMobile) 12.px else 16.px)
                                .fontWeight(FontWeight.Normal)
                                .color(Colors.Blue)
                                .fontFamily(INTER)
                        )
                    }
                } else {
                    SpanText(
                        text = getDefaultText(),
                        modifier = Modifier
                            .fontSize(if (isMobile) 14.px else 18.px)
                            .color(Colors.Black)
                            .fontFamily(INTER)
                    )
                }
                Box(
                    modifier = Modifier
                        .size(if (isMobile) 32.px else 40.px)
                        .border(1.px, LineStyle.Solid, Colors.Placeholder)
                        .borderRadius(7.px)
                        .cursor(Cursor.Pointer)
                        .onClick { onEdit() },
                    contentAlignment = Alignment.Center
                ) {
                    Image(
                        src = "/edit-icon.svg",
                        description = "editer",
                        modifier = Modifier
                            .size(if (isMobile) 18.px else 25.px)
                    )
                }
            }
        }
    }
}